export default __webpack_public_path__ + "static/media/img-0532-slovakia-full-face.ddf6873c.png";